<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 32 32"
  >
    <path
      v-if="name === 'gear'"
      d="M28.24 17.56c.06-.5.1-1.02.1-1.56a9.6 9.6 0 00-.12-1.56l3.48-2.64c.3-.24.39-.68.2-1.02l-3.29-5.54c-.2-.36-.64-.48-1-.36l-4.1 1.6a12.14 12.14 0 00-2.78-1.56L20.11.68A.81.81 0 0019.3 0h-6.58a.8.8 0 00-.8.68l-.62 4.24c-1 .4-1.93.94-2.78 1.56l-4.1-1.6a.82.82 0 00-1 .36l-3.3 5.54c-.2.36-.11.78.21 1.02l3.48 2.64a9.78 9.78 0 00-.02 3.12L.3 20.2c-.3.24-.39.68-.2 1.02l3.29 5.54c.2.36.64.48 1 .36l4.1-1.6c.87.64 1.77 1.16 2.78 1.56l.62 4.24c.08.4.4.68.82.68h6.58c.41 0 .76-.28.8-.68l.62-4.24c1-.4 1.93-.94 2.78-1.56l4.1 1.6c.36.14.8 0 1-.36l3.3-5.54a.76.76 0 00-.21-1.02l-3.44-2.64zM16 22a6.1 6.1 0 01-6.17-6c0-3.3 2.78-6 6.17-6a6.1 6.1 0 016.17 6c0 3.3-2.78 6-6.17 6z"
    />
    <path
      v-if="name === 'block'"
      d="M24.2 6.26l.4-.4-.45-.35A13.3 13.3 0 005.5 24.15l.35.44.4-.4L24.19 6.26zM7.8 25.74l-.4.4.45.35A13.3 13.3 0 0026.5 7.85l-.35-.44-.4.4L7.81 25.74zM.5 16a15.5 15.5 0 1131.01.01A15.5 15.5 0 01.5 16z"
    />
    <path v-if="name === 'mute'" d="M0 10v12h8l10 10V0L8 10H0z" />
    <g v-if="name === 'add'" transform="translate(0 5)">
      <path
        d="M6.77 8.73v.5h4.37v1.9H6.77v4.37h-1.9V11.14H.5V9.23H4.86V4.86h1.91v3.87zm18.91-2.91a5.32 5.32 0 11-10.63 0 5.32 5.32 0 0110.63 0zM9.23 20.36c0-.78.39-1.5 1.1-2.17a9.7 9.7 0 012.95-1.72c2.36-.95 5.2-1.42 7.08-1.42s4.73.47 7.1 1.42a9.69 9.69 0 012.93 1.72c.72.67 1.11 1.39 1.11 2.17v2.41H9.23v-2.4z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      default: "gear",
      type: String
    }
  }
};
</script>
